import React from 'react';

import SwitchPlanModal from '~/switch-plan-modal';
import StealProfileModal from '~/steal-profile-modal';
import ProfilesDisconnectedModal from '~/profiles-disconnected-modal';
import InstagramFirstCommentModal from '~/ig-first-comment-modal';
import TrialCompleteModal from '~/trial-complete-modal';
import DeleteCampaignModal from '~/delete-campaign-modal';
import ConnectChannelPrompt from '~/connect-channel-prompt';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import TrialCollaborationModal from '../../../trial-collaboration-modal';

const AppModals = () => {
  const {
    showSwitchPlanModal,
    showProfilesDisconnectedModal,
    showStealProfileModal,
    showInstagramFirstCommentModal,
    showTrialCompleteModal,
    showDeleteCampaignModal,
    showConnectChannelPrompt,
    showTrialCollaborationModal,
  } = useSelector((state) => state.modals);
  const location = useLocation();
  const isContentPath = location.pathname.startsWith('/content');
  return (
    <>
      {showProfilesDisconnectedModal && !isContentPath && (
        <ProfilesDisconnectedModal />
      )}
      {showSwitchPlanModal && <SwitchPlanModal />}
      {showInstagramFirstCommentModal && <InstagramFirstCommentModal />}
      {showStealProfileModal && <StealProfileModal />}
      {showTrialCompleteModal && <TrialCompleteModal />}
      {showDeleteCampaignModal && <DeleteCampaignModal />}
      {showConnectChannelPrompt && <ConnectChannelPrompt />}
      {showTrialCollaborationModal && <TrialCollaborationModal />}
    </>
  );
};

export default AppModals;
